// extracted by mini-css-extract-plugin
export default {"sideNavigationBar":"SideNavigationBar_sideNavigationBar__YqpcT"};